var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"my-2",attrs:{"dark":"","color":"teal","fab":"","right":"","bottom":"","fixed":""},on:{"click":_vm.pushRoute}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-arrow-left")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ffe974","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/BackToListBtn.vue
// module id = null
// module chunks = 